// src/components/CookieBanner.js
import { useState, useEffect } from "react";

export default function CookieBanner() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem("cookie_consent");
    if (!consent) {
      setVisible(true);
    }
  }, []);

  const acceptCookies = () => {
    localStorage.setItem("cookie_consent", "true");
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div className="fixed bottom-0 w-full bg-black text-white py-6 px-6 flex justify-between items-center z-50">
      <p className="text-sm max-w-[80%]">
        Usamos cookies para melhorar sua experiência. Ao continuar navegando, você concorda com nossa{" "}
        <a href="/politica-de-privacidade" target="_blank" className="underline text-[#389E0D]">
          Política de Privacidade
        </a>.
      </p>
      <button
        onClick={acceptCookies}
        className="ml-4 bg-[#389E0D] hover:bg-green-700 text-white text-sm font-semibold py-2 px-4 rounded"
      >
        Aceitar
      </button>
    </div>
  );
}
